import { createContext, useContext } from 'react';

import { type SidebarSectionName } from './sticky-section';

export type StickySidebarSectionContextValue = {
  section: SidebarSectionName | null;
  portalTarget: HTMLDivElement | null;
  onSectionLayoutChange: () => void;
};

export const StickySidebarSectionContext =
  createContext<StickySidebarSectionContextValue>({
    section: null,
    portalTarget: null,
    onSectionLayoutChange: () => undefined,
  });

export function useStickySidebarSection() {
  return useContext(StickySidebarSectionContext);
}
